<form class="w-100 h-100 form" [formGroup]="contactForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Editar (fondo para íconos blancos)</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner bg-footer">
        <img class="given-img" [src]="fileImg64" alt="img-footer-logo" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-footer-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image' : '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen de 35px x 35px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-footer-logo" type="file" accept="image/*" (change)="getBase64($event)"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Texto</mat-label>
        <input matInput placeholder="Texto " formControlName="name" required>
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{footerContactInfo.isSocialMedia ? 'Url' : 'Número de teléfono' }}</mat-label>
        <input matInput [placeholder]="footerContactInfo.isSocialMedia ? 'Url' : 'Número de teléfono' " formControlName="cellPhone" required>
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
  </div>


  <button class="vs-btn-blue" type="submit" [disabled]="contactForm.invalid">
    Guardar
  </button>

</form>
